import { render, staticRenderFns } from "./PrintLtcat.vue?vue&type=template&id=4505633e&scoped=true&"
import script from "./PrintLtcat.vue?vue&type=script&lang=js&"
export * from "./PrintLtcat.vue?vue&type=script&lang=js&"
import style0 from "./PrintLtcat.vue?vue&type=style&index=0&id=4505633e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505633e",
  null
  
)

export default component.exports